module.exports = __webpack_public_path__ + "static/img/recommend_product2_max2.e347465a.png";